import { TIIndicatorPointToHighChartIndicatorPointMapper } from "../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { IndicatorOptionModel } from "../models/drop-down-list/indicator-option.model";

export class TIIndicatorDataToMacdSeriesBuilder {
    public static map(indicator: IndicatorOptionModel, rawIndicatorData: TIIndicatorDataModel, indicatorConfig: any, mainYAxis: string): Array<any> {
        if (!indicatorConfig || !indicatorConfig.series) {
            return [];
        }

        let result: Array<any> = [];

        const macdHistSeries: any = indicatorConfig.series[0];
        const macdLineSeries: any = indicatorConfig.series[1];
        const macdSignalSeries: any = indicatorConfig.series[2];

        const macdSignalNeedZone = rawIndicatorData.needHighChartZone(macdSignalSeries.type);

        const builtSignalDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(rawIndicatorData, indicator.value, macdSignalNeedZone);
        macdSignalSeries.data = builtSignalDataPoints.points;
        
        if (macdSignalNeedZone) {
            macdSignalSeries.zones = builtSignalDataPoints.zones;
            rawIndicatorData.zones = builtSignalDataPoints.zones;
            macdSignalSeries.zoneAxis = 'x';
        }

        macdSignalSeries.name = rawIndicatorData.name;
        macdSignalSeries.zIndex = 2;
        macdSignalSeries.className = 'indicator-series ' + rawIndicatorData.getClassName();
        macdSignalSeries.yAxis = rawIndicatorData.chartAreaName + '-y-axis';
        macdSignalSeries.lastPrice = {
            enabled: mainYAxis != macdSignalSeries.yAxis,
            className: 'last-price-indicator-' + indicator.getClassName(),
            // color: 'rgba(0, 0, 0, 0)',
        };

        result.push(macdSignalSeries);

        if (rawIndicatorData.childIndicators?.length > 0) {
            const macdHist = rawIndicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('MACD_HIST') >= 0);
            if (macdHist) {
                const macdHistNeedZone = macdHist.needHighChartZone(macdHistSeries.type);
                const builtHistDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(macdHist, indicator.value, macdHistNeedZone);
                macdHistSeries.name = macdHist.name;
                macdHistSeries.data = builtHistDataPoints.points;
                macdHistSeries.yAxis = rawIndicatorData.chartAreaName + '-y-axis';
                macdHistSeries.className = macdHist.getClassName();
                result.push(macdHistSeries);
            }

            const macdLines = rawIndicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('MACD_SIGNAL_LINE') >= 0);
            if (macdLines) {
                const macdLineNeedZone = macdLines.needHighChartZone(macdLineSeries.type);
        
                const builtLineDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(macdLines, indicator.value, macdLineNeedZone);
                macdLineSeries.name = macdLines.name;
                macdLineSeries.zIndex = 2;
                macdLineSeries.data = builtLineDataPoints.points;
                macdLineSeries.className = 'indicator-series ' + macdLines.getClassName();

                if (macdLineNeedZone) {
                    macdLines.zones = builtLineDataPoints.zones;
                    macdLineSeries.zones = builtLineDataPoints.zones;
                    macdLineSeries.zoneAxis = 'x';
                }

                macdLineSeries.yAxis = rawIndicatorData.chartAreaName + '-y-axis';
            }

            result.push(macdLineSeries);
        }

        return result;
    }
}
